module.exports = __webpack_public_path__ + "static/media/spinner.eabe0a0f.gif";